import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Grid,
  Link,
  List,
  ListItem,
  Typography
} from '@mui/material';
import { PageContainer, theme } from '../PageContainer';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import { USUCEvent } from '../../models/USUCEvent';

const eventsSchedule: USUCEvent[] = [
  // {
  //   name: 'Maha Panchami',
  //   date: 'September 27, 2025',
  //   activities: [
  //     '17:04 CET Billa Nimantran',
  //     '17:30 CET Sondha Arati',
  //     '18:00 CET Cultural events',
  //     '20:00 CET Dinner'
  //   ],
  //   // registrationLink: 'https://usuc.yapsody.com/event/book/853089/31765559'
  // },
  {
    name: 'Maha Shashthi',
    date: 'October 16, 2026',
    activities: [
      '02:00 pm Shashthi Puja Start',
      '04:30 pm Billa Nimantran',
      '05:00 pm Kalparambha & Bodhon',
      '06:00 pm Amantran and Adhibas',
      '06:30 pm Sandhya Arati'
    ],
    // registrationLink: 'https://usuc.yapsody.com/event/book/853091/31765561'
  },
  {
    name: 'Maha Saptami',
    date: 'October 17, 2026',
    activities: [
      '09:00 am Saptami Puja Start',
      '09:45 am Naba Patrika Snan',
      '11:00 am Saptami Pushpanjali',
      '04:00 pm Saptami Sandhya Puja',
      '05:30 pm Sandhya Arati'
    ],
    // registrationLink: 'https://usuc.yapsody.com/event/book/853093/31765563'
  },
  {
    name: 'Maha Ashtami',
    date: 'October 18, 2026',
    activities: [
      '09:00 am Ashtami Puja Start',
      '11:00 am Ashtami Pushpanjali',
      '02:30 pm Kumari Puja',
      '05:30 pm Sandhya Arati'
    ],
    // registrationLink: 'https://usuc.yapsody.com/event/book/853095/31765565'
  },
  {
    name: 'Maha Nabami',
    date: 'October 19, 2026',
    activities: [
      '06:57 am Sandhi Puja',
      '08:30 am Sandhi Puja Pushpanjali',
      '09:00 am Nabami Puja',
      '11:00 am Nabami Pushpanjali',
      '02:30 pm Nabami Hom/Yajna and Sandhya Arati later'
    ],
    // registrationLink: 'https://usuc.yapsody.com/event/book/853097/31765567'
  },
  {
    name: 'Bijoya Dashami',
    date: 'October 20, 2026',
    activities: [
      '09:00 am Dashami Puja Start',
      '11:00 am Dashami Pushpanjali',
      '03:07 pm Visarjan',
      '04:00 pm Debi Bodhon & Sindoor Khela'
    ],
    // registrationLink: 'https://usuc.yapsody.com/event/book/853099/31765569'
  }
];

export const Event = () => {
  return (
    <PageContainer title="Durga Puja 2026 Schedule">
      <Grid item xs={15}>
        <Typography
          sx={{
            fontSize: '18px'
          }}
          variant="body1"
          align="center"
          color={'secondary'}
          component="p">
          <b>Venue:</b> ZIMIHC Theater Stefanus - Braziliëdreef 2, 3563 CK Utrecht, Netherlands
          <br />
          <br />
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <DaywiseEvents />
      </Grid>
      {/* <Grid item xs={15}>
        <Typography
          sx={{
            fontSize: '18px'
          }}
          variant="body1"
          align="center"
          color={'secondary'}
          component="p">
          <br />
          <br />
          <b>
            *For all other event passes go to{' '}
            <Link
              sx={{ textDecoration: 'none', color: '#c0c0c0' }}
              href="/#/register">
              Registration
            </Link>
          </b>
        </Typography>
      </Grid> */}
    </PageContainer>
  );
};

const DaywiseEvents = (props: any) => {
  return (
    <Grid container spacing={5} alignItems="flex-end">
      {eventsSchedule.map((event, index) => {
        return <DaywiseEvent event={event} />;
      })}
    </Grid>
  );
};

const DaywiseEvent = (props: any) => {
  const event: USUCEvent = props.event;
  return (
    <Grid item xs={12} md={4}>
      <Card>
        <CardHeader title={event.name} sx={{ textAlign: 'center' }} />
        <CardContent
          sx={{
            [theme.breakpoints.up('lg')]: {
              height: '410px'
            }
          }}>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexWrap: 'wrap'
            }}>
            <CalendarMonthIcon sx={{ marginRight: '15px' }} />
            <span>{event.date}</span>
          </div>

          <List>
            {event.activities?.map((item, index) => (
              <EventItem item={item} />
            ))}
          </List>
        </CardContent>
        {event.registrationLink? (<CardActions>
          <Button
            sx={{ marginLeft: '5px', marginRight: '5px' }}
            fullWidth
            variant={'contained'}
            color={'secondary'}
            href={`${event.registrationLink}`}
            target="_blank">
            Register Now*
          </Button>
        </CardActions>) : ('')}
      </Card>
    </Grid>
  );
};

const EventItem = (props: any) => {
  const item: string = props.item;
  const time = item.substring(0, 9);
  const description = item.substring(9);

  return (
    <ListItem>
      <Grid item xs={12}>
        {time} &nbsp; &nbsp;{description}
      </Grid>
    </ListItem>
  );
};
